module.exports = __webpack_public_path__ + "assets/images/SuccsesShape.4ddd24fd3150f3525a3c8869b99c3832.png";